import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Button from '../../../../../components/Buttons/Button';
import { ODSCopyField, ODSTextField } from '../../../../../components/InputFields';
import Modal from '../../../../../components/Modal';
import { useCopyToClipboard } from '../../../../../hooks/useCopyToClipboard';
import { removeMachineAccountTokens } from '../../../../../redux/safescarf/machineAccounts/actions';

export interface MachineAccountsApiKeyModalProps {
  machineAccountName?: string;
  machineAccountToken?: string;
}

const MachineAccountsApiKeyModal: React.FC<MachineAccountsApiKeyModalProps> = ({
  machineAccountName = '',
  machineAccountToken = '',
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const copyToClipboard = useCopyToClipboard();

  const handleCopy = (): void => {
    copyToClipboard(machineAccountToken);
  };

  const handleClose = (): void => {
    dispatch(removeMachineAccountTokens());
  };

  return (
    <Modal
      hideActions
      title='New Machine Account created'
      onClose={handleClose}
      submitLabel='Save'
    >
      <Typography gutterBottom>
        {intl.formatMessage({ id: 'safescarfMachineAccountCreated' })}
      </Typography>
      <Grid
        container
        direction='column'
        gap={2}
      >
        <Grid item>
          <ODSCopyField
            label='Username'
            name='username'
            value={machineAccountName}
            disabled
          />
        </Grid>
        <Grid item>
          <Typography
            fontWeight='bold'
            gutterBottom
          >
            {intl.formatMessage({ id: 'apiKeyGenerated' })}
          </Typography>
          <Typography>{intl.formatMessage({ id: 'apiKeyCopy1' })}</Typography>
          <Typography gutterBottom>{intl.formatMessage({ id: 'apiKeyCopy2' })}</Typography>
          <Grid
            container
            alignItems='center'
            gap={1}
          >
            <Grid
              item
              xs
            >
              <ODSTextField
                label='API key'
                name='APIkey'
                value={machineAccountToken}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item>
              <Button
                label='Copy'
                icon='copy-paste-type-standard'
                rightIcon
                onClick={handleCopy}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default MachineAccountsApiKeyModal;
